<template lang="pug">
  #site
    barra-governo
    page-header
    page-navbar
    router-view
    page-footer
</template>

<script>
import PageHeader from 'LAYOUTS/PageHeader'
import PageNavbar from 'LAYOUTS/PageNavbar'
import PageFooter from 'LAYOUTS/PageFooter'
import BarraGoverno from 'LAYOUTS/BarraGoverno'

export default {
  name: 'site',
  components: { PageHeader, PageNavbar, PageFooter, BarraGoverno }
}
</script>

<style lang="scss">
  #site {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 70px);
    height: auto;

    > #main {
      display: flex;
      flex: 1;
    }

    @include media("<tablet") {
      > #main > .container { width: 100% }
    }

    @include media(">=desktop") {
      min-height: 100vh;
    }

  }
</style>



// WEBPACK FOOTER //
// App.vue?13790488